import {Component, OnInit} from '@angular/core';
import {OrderService} from '../../services/order.service';
import {OrderdateService} from '../../services/orderdate.service';
import {Order} from '../../interfaces/order';

import {Utility} from '../../utility';
import * as Query from '../../global-query';
import {AppsyncService} from '../../services/appsync.service';
import * as _ from 'lodash';

import {IMyDpOptions} from 'mydatepicker';
import {HttpErrorResponse} from '@angular/common/http';
import {NgForm} from '@angular/forms';

import {UserService} from '../../services/user.service';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';

import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {FormControl} from '@angular/forms';
import {LoaderService} from '../loader/loader.service';
import {MockMenuService} from '../../services/mock-menu.service';
import {item} from '../../item';
import {ItonicsAuthService} from '../../services/itonicsAuth.service';
import { Subscription } from 'rxjs';
import { Settings } from '../../interfaces/setting';
import { SettingService } from '../../services/setting.service';

@Component({
  selector: 'app-user-order-list',
  templateUrl: './user-order-list.component.html',
  styleUrls: ['./user-order-list.component.scss']
})
export class UserOrderListComponent implements OnInit {
  orderSearchForm: FormGroup;
  searchResult = [];
  date: any;
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'yyyy-mm-dd',
    openSelectorOnInputClick: true
  };

  // Initialized to specific date (09.10.2018).
  public model: any = ''; //{ date: { year: 2018, month: 10, day: 9 } };
  userDatalist: any = [];
  public netTotal = 0;
  public extraTotal = 0;
  public userDate: any = '';
  public counterValue = 1;
  public userItemsList: Order[] = [];
  orderLists: Order[] = [];
  userOrderItemsList: any = [];
  orderList: any = [];

  settingSubscrition: Subscription;
  public settingsData: any = [];

  // userValueChangesSubscriber;

  public fromDate: any = false;
  public userId: any = false;
  public toDate: any = false;

  constructor(
    private orderService: OrderService,
    private appsync: AppsyncService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private ms: MockMenuService,
    private order_date: OrderdateService,
    private settingService: SettingService,
  ) {
  }

  ngOnInit() {
    this.orderSearchForm = this.formBuilder.group({
      // employee: ['', Validators.required],
      employee: [''],
      fromdate: ['', Validators.required],
      todate: ['']
    });

    // this.orderSearchForm.controls['employee'].valueChanges.subscribe((data) => {
    this.userService.search_word('').subscribe((response) => {
      console.log(response);
      this.searchResult = response;
    });
    // });
    // setdate
    this.order_date.orderdate.subscribe((date) => {
      this.date = date;
      this.orderSearchForm.patchValue({
        fromdate: {
          date: this.date.startDate
        }
      });
      this.orderSearchForm.patchValue({
        todate: {
          date: this.date.endDate
        }
      });
    });

    this.userService
      .getUserList()
      .toPromise()
      .then((data) => {
        this.userDatalist = data;
      });

  }

  displayFn(item): string {
    return item ? item.name : item;
  }

  getUserOrderList(fromdate, userId, todate) {
    this.fromDate = fromdate;
    this.userId = userId;
    this.toDate = todate;


    this.ms.showLoader();

    this.appsync.client.hydrated().then((client) => {
      const observable = client.watchQuery({
        query: Query.orderListByFilter,
        variables: {
          frmDate: fromdate,
          userId: userId,
          toDate: todate
        }
      });

      let settingdata;
      this.settingSubscrition = this.settingService.settings.subscribe((settings: Settings) => {
        settingdata = settings;
        if (settingdata.length == 0) {
          // console.log('no data')
          return
        }
        settingdata.forEach(element => {
          this.settingsData[element.alias] = element.value;
        });

      observable.subscribe(({data, loading}) => {
        if (!data) {
          return console.log('getUserOrder - no data');
        }

        console.log('getUserOrder', data);

        this.counterValue = 1;
        this.extraTotal = 0;
        this.netTotal = 0;
        this.userItemsList = [];
        this.userDate = '';

        this.orderLists = _(data.orderListByFilter)
          .sortBy('userId')
          .value();

        const reformattedArray = this.orderLists.map((obj) => {
          const newObject: any = Object.assign({}, obj);

          const userDetail = this.userDatalist.filter((u) => u.Username === obj.userId);
          if (userDetail[0]) {
            newObject.indexId = userDetail[0].name + ' ' + userDetail[0].family_name;
          } else {
            newObject.indexId = 'Anonymus';
          }

          newObject['date'] = Utility.convert(obj['date']);
          newObject.net = Math.round(obj['menuItem']['price'] * obj['quantity']);
          newObject.total = Math.round(obj.quantity * obj['menuItem'].price - obj.quantity * obj['menuItem'].price * 0.87 * (this.settingsData.discount / 100));
          /*  if (newObject.total > this.settingsData.lunchamount) {
              newObject.extra = newObject.total - this.settingsData.lunchamount;
              this.extraTotal += newObject.extra;
            } else {
              newObject.extra = '0';
            }*/

          this.netTotal += newObject.total;

          // if (this.userDate != obj['date']) {
          this.userDate = obj['date'];
          newObject['date'] = Utility.convert(obj['date']);
          /*} else {
            newObject['date'] = '';
          }*/

          return newObject;
        });

        this.userItemsList = reformattedArray;
        this.ms.hideLoader();

        if (this.userId === '') {
          this.userOrderItemsList = this.userItemsList.reduce((p, n) => {
            if (!p[n.userId]) {
              p[n.userId] = [];
            }
            p[n.userId].push(n);
            return p;
          }, {});

          this.orderList = [];
          Object.keys(this.userOrderItemsList).forEach((key) => {
            const tempObj = [];
            let total = 0;
            tempObj['data'] = this.userOrderItemsList[key];
            tempObj['date'] = this.userOrderItemsList[key][0].date;
            this.userOrderItemsList[key].forEach((value) => {
              total += value.total;
            });
            // test['extra'] = total;

            if (total > this.settingsData.lunchamount) {
              tempObj['extra'] = total - this.settingsData.lunchamount;
              this.extraTotal += tempObj['extra'];
            } else {
              tempObj['extra'] = '0';
            }

            // this.netToken += total;


            this.orderList.push(tempObj);
          });
        } else {
          this.userOrderItemsList = this.userItemsList.reduce((p, n) => {
            if (!p[n.date]) {
              p[n.date] = [];
            }
            p[n.date].push(n);
            return p;
          }, {});

          console.log(this.userOrderItemsList);

          this.orderList = [];
          Object.keys(this.userOrderItemsList).forEach((key) => {
            const tempObj = [];
            let total = 0;
            tempObj['data'] = this.userOrderItemsList[key];
            tempObj['date'] = key;
            this.userOrderItemsList[key].forEach((value) => {
              total += value.total;
            });
            // test['extra'] = total;

            if (total > this.settingsData.lunchamount) {
              tempObj['extra'] = total - this.settingsData.lunchamount;
              this.extraTotal += tempObj['extra'];
            } else {
              tempObj['extra'] = '0';
            }

            // this.netToken += total;


            this.orderList.push(tempObj);
          });

        }
        console.log(this.orderList);
      });

      })
    });
  }

  onSubmit() {
    const formValue = this.orderSearchForm.value;
    let fromDate, toDate = '';
    if (typeof formValue.fromdate !== 'undefined' && formValue.fromdate) {
      if (typeof formValue.fromdate.formatted !== 'undefined') {
        fromDate = formValue.fromdate.formatted;
      } else {
        fromDate = formValue.fromdate.date;
      }
    } else {
      fromDate = formValue.fromdate.date;
    }

    if (typeof formValue.todate !== 'undefined' && formValue.todate) {
      if (typeof formValue.todate.formatted !== 'undefined') {
        toDate = formValue.todate.formatted;
      } else {
        toDate = formValue.todate.date;
      }
    } else {
      if (formValue.todate) {
        toDate = formValue.todate.date;
      }
    }

    const userId = formValue.employee;

// Fetch the data according to filter:
    if (typeof fromDate === 'undefined') {
      alert('From Date is required');
      return false;
    } else if ((this.orderSearchForm.value.employee === '' && toDate !== '' && typeof toDate !== 'undefined')) {
      alert('You are not allowed to select To date if you are looking for all user records');
      return false;
    } else {
      this.getUserOrderList(fromDate, userId, toDate);
    }
  }

  setDateRange(data) {
    console.log(data);
  }

  removeUserOrder(_item: item) {
    if (confirm('Are you sure to delete ' + _item['menuItem']['title'])) {
      this.orderService.removeQuickOrder(_item.id).subscribe((something) => {
        this.userItemsList = this.userItemsList.filter((u) => u.id !== _item['id']);
      });
    }
  }

  editUserOrder(id, menuItemId) {
    window.location.href = ItonicsAuthService.AuthSystemUrl + '/home/edit/order/' + id + '/' + menuItemId;
  }

  printOrders() {
    let printContents, popupWin, title;
    title = 'Users Order';
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>${title}</title>
          <style>
          td{
                border-bottom: 1px solid #353535;
                border-right: 1px solid #353535;
          }
          .hide-print{
          display: none;
          }
          .menu-title span{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 200px;
            display: inline-block;
          }
           table th,
           table td{
          font-size: 10px;
          }
          tr.total{
                display: block;
             }
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    // popupWin.document.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/user-order-list/user-order-list.component.ts